/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Boiler_Type_Wood_BoilerInputs */



/**
* | output |
* | --- |
* | "Wood boiler" |
*
* @param {Boiler_Type_Wood_BoilerInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const boiler_type_wood_boiler = /** @type {((inputs?: Boiler_Type_Wood_BoilerInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Boiler_Type_Wood_BoilerInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Wood boiler")
	return /** @type {LocalizedString} */ ("Chaudière bois")
});